import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsSplitContentImageContent_Box_1 = styled.div`
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    width: 50%;
    padding-inline: ${gutterWidth / 2}px;
    padding-block: ${gutterWidth / 2}px;
  }

  &[data-not-full-width] {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      position: relative;
    }
  }

  &[data-not-image-text-block] {
    padding-inline: ${gutterWidth / 4}px;
    padding-block: ${gutterWidth / 4}px;

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      padding-inline: ${gutterWidth / 2}px;
      padding-block: ${gutterWidth / 2}px;
    }
  }
`;

export const CmsSplitContentImageContent_Box_2 = styled.div`
  overflow: hidden;
  height: 100%;
  width: 100%;
  margin-left: 0;

  &[data-fixed-width] {
    height: auto;
  }

  &[data-overlapping] {
    margin-top: 0;
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    left: 50%;
    top: 50%;

    &[data-centered] {
      position: absolute;
      transform: translate(-50%, -50%);
    }

    &[data-overlapping] {
      width: calc(100% + ${gutterWidth * 3}px);
      margin-top: -${gutterWidth}px;

      &:not([data-fixed-width]) {
        height: calc(100% + ${gutterWidth * 2}px);
      }
    }

    &[data-full-width]:not([data-overlapping]) {
      width: 100vw;

      &:not([data-fixed-width]) {
        height: calc(100% + ${gutterWidth}px);
      }
    }

    &[data-negative-margin-left] {
      margin-left: -${gutterWidth * 3}px;
    }
  }
`;
